<template>
  <div>
    <v-layout>
      <v-text-field
        :label="$t('PNR-No')"
        @blur="codeControl()"
        :placeholder="kodmesajı"
        append-icon="search"
        @click:append="dialogac()"
        :tabindex="tabdeger"
        v-model="val"
        hide-details=""
      ></v-text-field>
    </v-layout>
    <v-dialog scrollable="" persistent v-model="dialog" max-width="500px">
      <v-card flat color="grey lighten-5">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">{{$t('PNR-List')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                v-model="prm.Isim"
                :label="this.$t('Name')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-bind:detaygizle="true"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="prm.Kayit_Tarihi1"
                    v-model="prm.Kayit_Tarihi1"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    v-bind:detaygizle="true"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="prm.Kayit_Tarihi2"
                    v-model="prm.Kayit_Tarihi2"
                  ></tarihcomp>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <cariaracomp
                v-bind:etiket="$t('Currentcode_label')"
                v-bind:value="secilencari"
                v-model="secilencari"
                :Coper="true"
                required
                :rules="true"
              ></cariaracomp>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-btn small @click="Ara()" color="info" block>{{this.$t('Search')}}</v-btn>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card-actions>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-toolbar flat="" size="100px" dark color="info">
                        <v-toolbar-title>
                          <span class="subheading white--text">
                           {{$t('PNR-List')}}
                          </span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-flex xs6 sm6 md6>
                          <v-text-field
                            flat=""
                            solo-inverted=""
                            hide-details
                            v-model="searchsatilanbilet"
                            :label="this.$t('Search-found-records')"
                            append-icon="search"
                          ></v-text-field>
                        </v-flex>
                      </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-data-table
                        :headers="headersservis"
                        :loading="progress"
                        :items="items"
                        hide-actions
                        class="elevation-1"
                      >
                        <v-progress-linear
                          slot="progress"
                          indeterminate
                        ></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr @click="kabul(props.item)" item>
                            <td class="text-xs-left">
                              {{ props.item.PNR_No }}
                            </td>
                            <td class="text-xs-left">{{ props.item.Isim }}</td>
                            <td class="text-xs-left">
                              {{ props.item.Cari_Kod }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.Kayit_Tarihi | dateformat }}
                            </td>
                            <td class="justify-center layout px-0"></td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="filtreiptal()">
            {{ $t("cancel_button") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "@/components/app/customcomp/tarihim.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";

export default {
  props: ["value", "tabdeger"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  beforeMount: beforeMount,
  components: {
    tarihcomp,
    genelarama,
    cariaracomp,
  },
  methods: {
    filtreiptal() {
      this.prm.Isim = null;
      this.prm.Kayit_Tarihi1 = null;
      this.prm.Kayit_Tarihi2 = null;
      this.prm.Cari_Kod = null;
      this.secilencari = null;
      this.dialog = false;
    },
    Ara() {
      if (this.secilencari != null) {
        this.prm.Cari_Kod = this.secilencari.id;
      } else {
        this.prm.Cari_Kod = null;
      }
      setTimeout(() => {
        tool.http_post(this, "PNRAra", this.prm).then(
          (response) => {
            this.items = response.body;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
      }, 500);
    },
    kayitgetir: kayitgetir,
    dialogac: dialogac,
    kabul: kabul,
    codeControl: codeControl,
  },
  data() {
    return {
      searchsatilanbilet: null,
      secilencari: null,
      prm: {
        Isim: null,
        Cari_Kod: null,
        Kayit_Tarihi1: null,
        Kayit_Tarihi2: null,
      },
      headersservis: [
        {
          text: "PNR",
          value: "BolumKodu",
        },
        {
          text: this.$t('Name'),
          value: "BolumAdi",
        },
        {
          text: this.$t('Current'),
          value: "BolumAdi",
        },
        {
          text: this.$t('Date'),
          value: "BolumAdi",
        },
      ],
      kodmesajı: null,
      progress: false,
      items: [],
      aranacakkelime: null,
      secilendeger: null,
      dialog: false,

      text1: null,
      loading: false,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
    };
  },

  watch: {
    secilendeger(val) {
      val && this.kayitgetir(val);
    },
    dialog(val2) {
      if (!val2) return;
      requestAnimationFrame(() => {
        //  this.$refs.ara.focus()
      });
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};

function codeControl() {
  if (this.val != null && this.val != "") {
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    var params1 = {
      CompanyCode: credentials.SirketKodu,
      SectionCode: escape(this.val),
    };
    this.$http
      .post(auth.API_URL + "api/Definitions/SectionGet", params1, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if (response.body.length == 1) {
            this.val = response.body[0].BolumKodu;
            this.kodmesajı = null;
          } else {
            this.kodmesajı = this.$t('Incorrect-code-entry')
            this.val = null;
          }
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-bolum";
            this.snackbar = true;
            this.progress = false;
          } else {
            this.text1 = "Service Unavailable-bolum";
            this.snackbar = true;
            this.progress = false;
          }
        }
      );
  } else {
    this.kodmesajı = null;
  }
}

function kabul(m) {
  this.val = m.PNR_No;
  this.dialog = false;
}

function dialogac() {
  this.dialog = true;
}

function beforeMount() {}

function kayitgetir(y) {
  if (y != null) {
    if (y.length > 2) {
      this.progress = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params1 = {
        CompanyCode: credentials.SirketKodu,
        SectionSearch: escape(y),
      };
      this.$http
        .post(auth.API_URL + "api/Definitions/SectionSearch", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.items = response.body;

            this.progress = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-bolum";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-bolum";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    } else {
      this.items = [];
      this.progress = false;
    }
  }
}
</script>